/**
 * Use this to link a {core/FormField.field} object to an input element.
 */
define('ko/customBinding/inputField',['knockout'], function(ko) {

    // @todo @dancras Test this
    ko.bindingHandlers.inputField = {
        init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {

            var field = valueAccessor();

            ko.applyBindingsToNode(
                element,
                {
                    disable: field.isDisabled,
                    hasFocus: field.isFocused,
                    validationClasses: field,
                    formField: field
                },
                bindingContext
            );
        }
    };

});

